/* istanbul ignore file */
// libraries
import React from 'react';
// components
import { LoadDropdown } from 'framework/form';
import { IGNORE_ROLES_ON_FE, useCompanyRolesService } from '../companyRolesService';

type CompanyRolesInputProps = Omit<React.ComponentProps<typeof LoadDropdown>, 'loadDataMethod' | 'mapResults'>;

const CompanyRolesInput = ({ sx, ...props }: CompanyRolesInputProps) => {
  const { searchAll } = useCompanyRolesService();

  const mapRoleData = (roleName: any) => ({
    value: roleName,
    label: roleName,
  });

  const getAvaliableCompanyRoles = async () => {
    const responce = await searchAll();

    const elements = responce.result.filter(item => !IGNORE_ROLES_ON_FE.includes(item));

    return {
      ...responce,
      totalElements: elements.length,
      result: elements,
    };
  };

  return (
    <LoadDropdown
      loadDataMethod={getAvaliableCompanyRoles}
      mapResults={mapRoleData}
      placeholder="Select role"
      sx={[{ minWidth: '300px' }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  );
};

export default CompanyRolesInput;
